import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

const CircularLoading = ({
    size,
    marginTop,
    marginLeft,
}) => (
    <CircularProgress
        size={size}
        style={{
            marginLeft: `${marginLeft}%`,
            marginTop: `${marginTop}%`,
            color: '#008299',
        }}
    />
);

CircularLoading.propTypes = {
    size: PropTypes.number.isRequired,
    marginTop: PropTypes.number.isRequired,
    marginLeft: PropTypes.number,
};

CircularLoading.defaultProps = {
    marginLeft: 50,
};

export default CircularLoading;